import { useState } from 'react';
import { ArrowUpCircle, X, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SdkUpdateBannerProps {
  from: string | null;
  to: string;
  hasBreaking: boolean;
  isUpgrading: boolean;
  onUpgrade: () => void;
}

export function SdkUpdateBanner({
  from,
  to,
  hasBreaking,
  isUpgrading,
  onUpgrade,
}: SdkUpdateBannerProps) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="border-b bg-blue-50 dark:bg-blue-950/20 px-4 py-2 flex items-center gap-2">
      <ArrowUpCircle className="h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400" />
      <span className="flex-1 text-xs text-blue-800 dark:text-blue-200">
        SDK update available{from ? ` (v${from} \u2192 v${to})` : ` (v${to})`}.
        {hasBreaking && ' Includes breaking changes \u2014 AI will review and fix your code.'}
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-6 text-xs"
        onClick={onUpgrade}
        disabled={isUpgrading}
      >
        {isUpgrading ? <Loader2 className="h-3 w-3 animate-spin mr-1" /> : null}
        {isUpgrading ? 'Updating...' : 'Update'}
      </Button>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200"
        aria-label="Dismiss"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
